import { useState } from 'react';
import styled from 'styled-components';
import { mqLargeMin } from 'styled/tools/media-queries';
import LazyMediaItem from 'components/reusable/Lazy/lazy-media-item';
import ProductLightbox from 'components/pdp/product-lightbox';

const MediaGrid = styled.div`
  margin-bottom: 1.375rem;
  display: flex;
  overflow: auto;
  column-gap: 0.5rem;

  @media ${mqLargeMin} {
    margin-bottom: 0;
    margin-right: 2rem;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 1rem;
    grid-row-gap: 1rem;
    max-width: 944px;

    & :first-child {
      grid-column: 1 / span 2;
    }
  }
`;

const LightboxButton = styled.button`
  appearance: none;
  border-radius: 1rem;
  max-height: 16.5625rem;
  min-width: 21.875rem;
  border: none;
  background: transparent;
  cursor: pointer;
  overflow: hidden;

  @media ${mqLargeMin} {
    &:first-of-type {
      border-radius: 2rem;
      max-height: 40.5rem;
    }

    min-width: unset;
  }
`;

const MediaGallery = ({ media }) => {
  const [lightboxItem, setLightboxItem] = useState(false);

  return (
    <>
      <MediaGrid>
        {media.map((mediaItem, index) => (
          <LightboxButton
            key={`media-item-${index}`}
            onClick={() => setLightboxItem(mediaItem)}
            aria-label={
              mediaItem.previewImage?.altText
                ? `View larger image: ${mediaItem.previewImage.altText}`
                : 'View larger image'
            }
          >
            <LazyMediaItem
              media={mediaItem}
              mediaType={mediaItem.mediaContentType}
              mediaSize={index === 0 ? 'large' : 'medium'}
            />
          </LightboxButton>
        ))}
      </MediaGrid>
      <ProductLightbox
        mediaItems={media}
        lightboxItem={lightboxItem}
        setLightboxItem={setLightboxItem}
      />
    </>
  );
};

export default MediaGallery;
